export const PATH_WORK_LOGS = "/member/work-logs";

export const PATH_WORK_LOGS_EDIT = PATH_WORK_LOGS + "/edit/:workLogId";

export function getPathWorkLogEdit(workLogId: string) {
  return PATH_WORK_LOGS + "/edit/" + workLogId;
}
